const glassConnectionTypes = [
  'leftlong',
  'rightlong',
  'miter',
  'meeting2k',
  'nomeeting',
];

export default glassConnectionTypes;
